import { h } from 'preact';
import { TextCheckboxList } from './TextCheckboxList';
import { ColorSwatch } from './ColorSwatch';
import { RangeSlider } from './RangeSlider';
import styles from './Filter.module.scss';
import { Caret } from '../icons/caret';
export function Filter({ filter, onFilterChange, layout, isOpen, onToggle, }) {
    const renderFilter = () => {
        switch (filter.type) {
            case 'text':
            case 'select':
                return (h(TextCheckboxList, { layout: layout, options: filter.options || [], onChange: (value) => onFilterChange(filter.id, value) }));
            case 'color':
                return (h(ColorSwatch, { options: filter.options || [], onChange: (value) => onFilterChange(filter.id, value) }));
            case 'range':
                return (h(RangeSlider, { min: filter.min || 0, max: filter.max || 1000, gap: 10, currentMin: filter.currentMin || 0, currentMax: filter.currentMax || 1000, onChange: (value) => onFilterChange(filter.id, value.toString()) }));
            default:
                return null;
        }
    };
    return (h("div", { class: styles.filter },
        h("h3", { class: styles.filterLabel, onClick: onToggle },
            filter.label,
            h("span", { class: `${styles.caret} ${isOpen ? styles.caretOpen : ''}` },
                h(Caret, null))),
        isOpen && h("div", { class: styles.filterContent }, renderFilter())));
}
